export default "__VITE_ASSET__4HtxgRbi__"